
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24"
  },
  "children": [
    {
      "tag": "defs",
      "children": [
        {
          "tag": "clipPath",
          "attrsMap": {
            "id": "clip-path"
          },
          "children": [
            {
              "tag": "rect",
              "attrsMap": {
                "id": "矩形_11415",
                "data-name": "矩形 11415",
                "class": "cls-1",
                "width": "24",
                "height": "24",
                "transform": "translate(0.5 0)"
              }
            }
          ]
        }
      ]
    },
    {
      "tag": "g",
      "attrsMap": {
        "id": "蒙版组_352",
        "data-name": "蒙版组 352",
        "class": "cls-2",
        "transform": "translate(-0.5 0)"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "id": "yugang",
            "class": "cls-3",
            "d": "M3.57,0A2.075,2.075,0,0,1,5.607,2.012l0,.106a.51.51,0,1,1-1.02,0,1.044,1.044,0,0,0-.944-1.056l-.076,0a1.036,1.036,0,0,0-1.017.979l0,.079V8.471H19.38A1.04,1.04,0,0,1,20.4,9.529v.794a1.856,1.856,0,0,1-1.077,1.7A6.94,6.94,0,0,1,16.885,16.5l.682,1.062a.292.292,0,0,1,.023.27.275.275,0,0,1-.206.167l-.044,0H17.1a.5.5,0,0,1-.386-.183l-.038-.053L16.19,17a6.419,6.419,0,0,1-3.44,1H7.65a6.419,6.419,0,0,1-3.439-1l-.49.762A.505.505,0,0,1,3.3,18H3.06a.272.272,0,0,1-.241-.15.292.292,0,0,1,.014-.291L3.515,16.5a6.94,6.94,0,0,1-2.438-4.472A1.856,1.856,0,0,1,0,10.324V9.529A1.04,1.04,0,0,1,1.02,8.471h.51V2.118A2.08,2.08,0,0,1,3.57,0ZM18.147,12.177H2.263a.109.109,0,0,0-.107.111V12.3l0,.011A5.673,5.673,0,0,0,7.5,16.939l.147,0h5.1a5.668,5.668,0,0,0,5.493-4.632.115.115,0,0,0-.017-.084.107.107,0,0,0-.069-.047Zm.723-2.648H1.53a.52.52,0,0,0-.51.529v.265a.783.783,0,0,0,.692.79l.073,0h16.83a.777.777,0,0,0,.761-.718l0-.076v-.265a.52.52,0,0,0-.51-.529Z",
            "transform": "translate(2.4 3.6)"
          }
        }
      ]
    }
  ]
})
    }
  